import {PageRoute, BasePageDefinitions} from "@reapptor-apps/reapptor-react-common";

export default class PageDefinitions extends BasePageDefinitions {

    protected async require(pageContainer: string, pageName: string): Promise<any> {
        return await require(`../pages/${pageContainer}${pageName}/${pageName}`);
    }
    
    constructor() {
        super();
    }

    public static readonly logoutRouteName: string = "Logout";

    public static readonly dummyRouteName: string = "Dummy";

    public static readonly dummyRoute: PageRoute = new PageRoute(PageDefinitions.dummyRouteName);

    public static readonly accountRouteName: string = "Account";

    public static readonly loginRouteName: string = "Login";

    public static readonly loginRoute: PageRoute = new PageRoute(PageDefinitions.loginRouteName);

    public static readonly adminRouteName: string = "Admin";

    public static readonly adminRoute: PageRoute = new PageRoute(PageDefinitions.adminRouteName);

    public static readonly dashboardRouteName: string = "Dashboard";

    public static readonly dashboardRoute: PageRoute = new PageRoute(PageDefinitions.dashboardRouteName);

    public static readonly errorRouteName: string = "Error";

    public static readonly errorRoute: PageRoute = new PageRoute(PageDefinitions.errorRouteName);

    public static readonly contactSupportRouteName: string = "ContactSupport";

    public static readonly contactSupportRoute: PageRoute = new PageRoute(PageDefinitions.contactSupportRouteName);

    public static readonly offlineRouteName: string = "Offline";

    public static readonly offlineRoute: PageRoute = new PageRoute(PageDefinitions.offlineRouteName);

    public static readonly changePasswordRouteName: string = "ChangePassword";

    public static readonly changePasswordRoute: PageRoute = new PageRoute(PageDefinitions.changePasswordRouteName);

    public static readonly forgotPasswordRouteName: string = "ForgotPassword";
    
    public static readonly forgotPasswordRoute: PageRoute = new PageRoute(PageDefinitions.forgotPasswordRouteName);
    
    public static readonly resetPasswordRouteName: string = "ResetPassword";

    public static readonly resetPasswordRoute: PageRoute = new PageRoute(PageDefinitions.resetPasswordRouteName);

    public static readonly homeRouteName: string = "Home";

    public static readonly homeRoute: PageRoute = new PageRoute(PageDefinitions.homeRouteName);

    public static readonly userManagementRouteName: string = "UserManagement";

    public static readonly userManagementRoute: PageRoute = new PageRoute(PageDefinitions.userManagementRouteName);

    public static readonly applicationSettingsRouteName: string = "ApplicationSettings";

    public static readonly applicationSettingsRoute: PageRoute = new PageRoute(PageDefinitions.applicationSettingsRouteName);

    public static readonly adminConsoleRouteName: string = "AdminConsole";

    public static readonly adminConsoleRoute: PageRoute = new PageRoute(PageDefinitions.adminConsoleRouteName);

    public static readonly testsRouteName: string = "Tests";

    public static readonly testsRoute: PageRoute = new PageRoute(PageDefinitions.testsRouteName);

    // #region Cruise

    public static readonly cruiseOrdersRouteName: string = "CruiseOrders";

    public static readonly cruiseOrdersRoute: PageRoute = new PageRoute(PageDefinitions.cruiseOrdersRouteName);

    public static readonly cruiseMyOrdersRouteName: string = "CruiseMyOrders";

    public static readonly cruiseMyOrdersRoute: PageRoute = new PageRoute(PageDefinitions.cruiseMyOrdersRouteName);
    
    public static readonly cruiseCountriesRouteName: string = "CruiseCountries";

    public static readonly cruiseCountriesRoute: PageRoute = new PageRoute(PageDefinitions.cruiseCountriesRouteName);

    public static readonly cruiseCountryManagementRouteName: string = "CruiseCountryManagement";

    public static readonly cruiseCountryManagementRoute: PageRoute = new PageRoute(PageDefinitions.cruiseCountryManagementRouteName);

    public static readonly cruiseCountryManagement: (countryId: string) => PageRoute = (countryId: string) => new PageRoute(PageDefinitions.cruiseCountryManagementRouteName, null, countryId);

    // #region Cruise Wizard

    public static readonly cruiseWizardStartRouteName: string = "Cruise/Start";

    public static readonly cruiseWizardStartRoute: PageRoute = new PageRoute(PageDefinitions.cruiseWizardStartRouteName);

    public static readonly cruiseWizardAreaRouteName: string = "Cruise/Area";

    public static readonly cruiseWizardAreaRoute: PageRoute = new PageRoute(PageDefinitions.cruiseWizardAreaRouteName);

    public static readonly cruiseWizardPassengersInfoRouteName: string = "Cruise/PassengersInfo";

    public static readonly cruiseWizardPassengersInfoRoute: PageRoute = new PageRoute(PageDefinitions.cruiseWizardPassengersInfoRouteName);

    public static readonly cruiseWizardCommentsRouteName: string = "Cruise/Comments";

    public static readonly cruiseWizardCommentsRoute: PageRoute = new PageRoute(PageDefinitions.cruiseWizardCommentsRouteName);

    public static readonly cruiseWizardContactsRouteName: string = "Cruise/Contacts";

    public static readonly cruiseWizardContactsRoute: PageRoute = new PageRoute(PageDefinitions.cruiseWizardContactsRouteName);

    public static readonly cruiseWizardCountryRouteName: string = "Cruise/Country";

    public static readonly cruiseWizardCountryRoute: PageRoute = new PageRoute(PageDefinitions.cruiseWizardCountryRouteName);

    public static readonly cruiseWizardDateRouteName: string = "Cruise/Date";

    public static readonly cruiseWizardDateRoute: PageRoute = new PageRoute(PageDefinitions.cruiseWizardDateRouteName);

    public static readonly cruiseWizardDurationRouteName: string = "Cruise/Duration";

    public static readonly cruiseWizardDurationRoute: PageRoute = new PageRoute(PageDefinitions.cruiseWizardDurationRouteName);

    public static readonly cruiseWizardExtraRouteName: string = "Cruise/Extra";

    public static readonly cruiseWizardExtraRoute: PageRoute = new PageRoute(PageDefinitions.cruiseWizardExtraRouteName);

    public static readonly cruiseWizardGroupRouteName: string = "Cruise/Group";

    public static readonly cruiseWizardGroupRoute: PageRoute = new PageRoute(PageDefinitions.cruiseWizardGroupRouteName);

    public static readonly cruiseWizardSummaryRouteName: string = "Cruise/Summary";

    public static readonly cruiseWizardSummaryRoute: PageRoute = new PageRoute(PageDefinitions.cruiseWizardSummaryRouteName);

    public static readonly cruiseWizardTimeOfDayRouteName: string = "Cruise/TimeOfDay";

    public static readonly cruiseWizardTimeOfDayRoute: PageRoute = new PageRoute(PageDefinitions.cruiseWizardTimeOfDayRouteName);

    public static readonly cruiseWizardCallRouteName: string = "Cruise/Call";

    public static readonly cruiseWizardCallRoute: PageRoute = new PageRoute(PageDefinitions.cruiseWizardCallRouteName);

    // #endregion

    // #endregion
}

new PageDefinitions();